module.exports = __webpack_public_path__ + "static/media/heroGraphic1200.b480ec72.png";